export const Events = {
    openStorePicker(this: void) {
        document.dispatchEvent(new Event('ES_BRANCH_MODAL_OPEN'))
    },
}
